<!--
 * @描述: 电子名片直销员头部介绍
 * @作者: Phil.Yu
 * @时间: 2021年04月02日
-->
<template>
  <div v-if="login">
    <div class="a_position_r boxSizing">
      <div class="a_position_r bg">
        <!-- <div class="bg">
          <img src="@/assets/electronicCard/bg.png" alt="" style="width:100%;height:100%">
        </div> -->
        <div class="a_position_a bg" style="top:0" v-if="callingcard">
          <HeaderCard :callingcard="callingcard" :shareId="shareId" :locationNumber="locationNumber"></HeaderCard>
        </div>
      </div>
      <div class="flex a_flex_a" style="padding:0 16px;margin-top:16px" v-if="recommendImageList&&recommendImageList.total>0">
        <div class="a_position_r" style="width:100%;height:20px">
          <div v-if="recommendImageList.data&&recommendImageList.data.length>3">
            <div v-for="(item,index) in recommendImageList.data" :key="index">
              <img :src="item.avatarUrl" alt="" style="border: 1px solid #C6DCFA;box-sizing: border-box;width:24px;height:24px;border-radius: 50px;" v-if="index<5" class="a_position_a" :style="{'left':index>0?`${(index)*15}px`:'0px'}">
            </div>
            <div class="a_position_a" :style="{'left':recommendImageList.data.length>0?`${(recommendImageList.data.length+1)*15}px`:'0px'}" 
            style="font-size: 16px;line-height: 22px;color: #7D7E80;">
            {{recommendImageList.data[0].name||recommendImageList.data[0].nickName}}等{{recommendImageList.total}}人浏览过
            </div>
          </div>
          <div v-else>
            <div v-if="recommendImageList.data&&recommendImageList.data.length" class="flex a_flex_a">
              <div v-for="(item,index) in recommendImageList.data" :key="index" style="margin-right:2px">
                <img :src="item.avatarUrl" alt="" style="border: 1px solid #C6DCFA;box-sizing: border-box;width:24px;height:24px;border-radius: 50px;">
              </div>
              <div style="font-size: 16px;line-height: 22px;color: #7D7E80;margin-left:6px;">
                {{recommendImageList.data[0].name||recommendImageList.data[0].nickName}}{{recommendImageList.total>1?`等${recommendImageList.total}人`:''}}浏览过
              </div>
            </div>
            <div v-else style="font-size: 16px;line-height: 22px;color: #7D7E80;">
              {{recommendImageList.total}}人浏览过
            </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <div style="padding: 0 16px;margin-top:31px">
        <div v-if="activityList.length">
          <div class="title flex a_flex_j_sb">
            <div style="font-weight: 600;">推荐门店活动</div>
            <div class="flex a_flex_a" @click="clickActivityList">
              <span style="font-size: 14px;line-height: 22px;color: #2F80ED;">更多</span>
              <img src="@/assets/electronicCard/right02.png" alt="" style="width:16px;height:16px">
            </div>
          </div>
          <div style="margin-top:12px">
            <van-swipe :autoplay="3000">
              <van-swipe-item
                v-for="(item, index) in activityList"
                :key="index"
                style="height: 200px"
              >
              <div class="a_position_r" style="width:100%;height: 200px;">
                  <img v-lazy="item.bannerUrl" style="width: 100%; height: 200px;border-radius: 5px;"/>
                  <div class="a_position_a swipeItemTitle text_overFlow" style="width:100%;bottom:0px;z-index:10;border-radius:0 0 5px 5px;">{{item.activityName}}</div>
                  <div class="a_position_a" style="width:100%;top:0px;z-index:11;height: 200px" v-if="initwx&&!callingcardShow">
                      <LinkWeappBtn :url="`/pages/detail.html?id=${item.activityId}&shareId=${shareId}`" @launch="launch(item.activityId)">
                        <script type="text/wxtag-template">
                          <style>
                            .style{
                              width:343px;height:200px;
                            }
                          </style>
                          <div class="style"></div>
                         </script>
                      </LinkWeappBtn>
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <div v-if="contentList.length" style="margin-top:32px">
          <div class="title flex a_flex_j_sb">
            <div style="font-weight: 600;">
               推荐优质内容
            </div>
            <div class="a_position_r">
                  <div class="flex a_flex_a">
                    <span style="font-size: 14px;line-height: 22px;color: #2F80ED;">更多</span>
                    <img src="https://aosnext-test-img.hotwater.com.cn/images/20210424/d2e436e585ee48bdbbeb9d2d1a7ee4d1.png" alt="" style="width:16px;height:16px">
                  </div>
                  <div class="a_position_a" style="top:0;z-index:10;width:100%;height:100%" v-if="initwx&&!callingcardShow">
                    <LinkWeappBtn :url="`pages/tabbar.html`">
                      <script type="text/wxtag-template">
                         <style>
                            .style{
                              width:44px;height:22px;
                            }
                          </style>
                          <div class="style"></div>
                       </script>
                    </LinkWeappBtn>
                  </div>
            </div>
          </div>
          <div  style="padding-bottom:80px">
            <div v-for="(item,index) in contentList" :key="index" style="background: #fff;padding:0 16px;border-radius: 5px;margin-top:12px;">
              <MaterialCard
                :item="item.model"
                @link="link(item.model.id)"
              ></MaterialCard>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
          <van-button
          style="color:#fff;border-radius:50px;font-size:16px;border:none; width:100%;height:44px;background:linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);font-family: PingFang SC;font-style: normal;"
          round
          @click="clickAdvisory"
        >
          <div class="flex a_flex_a a_flex_j">
            <img
              src="@/assets/electronicCard/advisory.svg"
              style="width:24px; height:24px; margin-right: 8px"
            />
            <span>点我咨询</span>
          </div>
        </van-button>
      </div>
    </div>
    <div v-if="callingcard&&callingcardShow">
      <VCardNew
        :posterData="callingcard"
        :eacrdImg="eacrdImg"
        @showMark="()=>callingcardShow=false"
        @imgOK="onImgOK"
      ></VCardNew>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import HeaderCard from "./components/HeaderCard";
import MaterialCard from "./components/MaterialCard";
import LinkWeappBtn from "@/components/LinkWeappBtn";
import VCardNew from "@/components/VCardNew"
// import storeData from '@/store/index'
export default {
  components: {
    HeaderCard,
    MaterialCard,
    LinkWeappBtn,
    VCardNew
  },
  data() {
    return {
      successImgs: [],
      materialList: [],
      callingcard:null,//名片基础信息
      shareId:'',//分享id
      activityList:[],//推荐活动
      contentList:[],//推荐内容
      recommendImageList:null, //推荐人头像
      vcardData:null,
      callingcardShow:false,
      login:false,
      eacrdImg:'',//海报
      multiChannelId:"",//渠道id
      locationNumber:"",//距离
    };
  },
  watch:{

  },
  async mounted(){
      //http://localhost:8081/#/electronicCard/details?state=LC2104271640000001
      this.shareId=this.$route.query.shareId||this.$route.query.state
      if(this.shareId){
        Vue.ss.set('shareId',this.shareId)
        await this.init()
      }
  },
  methods: {
      launch(activityId){
        console.log(activityId)
       this.$store.dispatch('wxLogin/getLogSave', {targetId:activityId,shareId:this.shareId,targetType:"ACTIVITY"})
      },
      link(id){
        let token=Vue.ls.get('ssToken')
        if(token) {
          this.$store.dispatch('wxLogin/getLogSave', {targetId:id,shareId:this.shareId,targetType:"CONTENT"})
         let urlH5 ="./material";
          let urlHH = `${urlH5}?id=${id}&shareId=${this.shareId}&multiChannelId=${this.multiChannelId}`;
          this.$router.push(urlHH)
        }else{
          Vue.ss.set('wxUserInfoLogin','wxUserInfoLogin')
          Vue.ss.set('pageUrl',`shareId=${this.shareId}`)
          this.$store.dispatch("wxLogin/wxUserInfoLogin")
        }

      },
      async init(){
        let redirectUri=`electronicCard/details`
         Vue.ss.set('pageUrl',`shareId=${this.shareId}`)
         Vue.ss.set('pageState',`${this.shareId}`)
         Vue.ss.set('redirectUri',redirectUri)
        this.$store.dispatch("wxLogin/wxLogin").then(async ()=>{
          let token=await this.$store.dispatch("wxLogin/getCheckToken")
          if(token){
            this.login=true
            if (!this.$root.$data.store.state.isInitWx) {
               this.$root.$data.store.initwx(true)
            }
            Vue.ss.remove('pageState')
            Vue.ss.remove('pageUrl')
            this.$store.dispatch('wxLogin/getLogSave', {targetId:"",shareId:this.shareId,targetType:"CARD"})
            this.callingcard=await this.getCardDetail()
            if(this.callingcard){
              this.readyShare()
              this.initwx=true
              if(this.callingcard.storeLocation){
                let that=this
                window.wx.ready(()=>{
                  that.getStoreLocation()
                })
              }
            }
            this.getRecommendImage()
            this.getRecommendActivityl()
            this.getRecommendContent()
          }
        });
      },
      //初始化分享
      getForward(){
        console.log('初始化分享')
        return new Promise((s)=>{
        this.$http
          .get(`aocampaigncallingcard/openapi/customer/callingcard/forward-init/CUSTOMER/${this.shareId}?openId=${Vue.ls.get('ssOpenId')}`)
          .then((res) => {
            console.log('初始化分享id',res.data)
            if(res.data&&res.data.shareId){
              s(res.data.shareId)
            }
          })
        })
      },
      async readyShare() {
        let that=this;
         let forwardShareid=await that.getForward()
         if(forwardShareid){
           console.log('初始化分享获得id',forwardShareid)

          window.wx.ready(async () => {
            console.log(112,forwardShareid)
            const shareUrl = `${location.origin}${location.pathname}#/electronicCard/details?shareId=${forwardShareid}`
            console.log('shareUrl',shareUrl)
            console.log('this.callingcard',this.callingcard)
            //需在用户可能点击分享按钮前就先调用
            window.wx.onMenuShareAppMessage({
              title: '分享这个不错的 A.O.史密斯专业顾问给你', // 分享标题
              desc: this.callingcard.name +" "+ this.callingcard.position, // 分享描述
              link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:'https://aosnext-test-img.hotwater.com.cn/images/20210423/a5a9a792604342b2985f5a627ce9a8cc.png', // 分享图标
              success: () => {
                this.$store.dispatch('wxLogin/getLogSave', {targetId:"",shareId:forwardShareid,targetType:"RECOMMEND"})
                that.shareSuccess(forwardShareid)
                // 用户点击了分享后执行的回调函数
              },
            })
            window.wx.onMenuShareTimeline({
              title: '分享这个不错的 A.O.史密斯专业顾问给你', // 分享标题
              link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:'https://aosnext-test-img.hotwater.com.cn/images/20210423/a5a9a792604342b2985f5a627ce9a8cc.png', // 分享图标
              success: () => {
                this.$store.dispatch('wxLogin/getLogSave', {targetId:"",shareId:forwardShareid,targetType:"RECOMMEND"})
                that.shareSuccess(forwardShareid)
                // 用户点击了分享后执行的回调函数
              },
            })
          })
         }
      },
      //转发分享
      shareSuccess(forwardShareid){
        console.log('转发成功',forwardShareid)
        this.$http
          .get(`aocampaigncallingcard/openapi/customer/callingcard/forward/${forwardShareid}?openId=${Vue.ls.get('ssOpenId')}&spreadSource=CUSTOMER&spreadStatus=SUCCESS`)
          .then(() => {
          })
      },
      //查看名片基础信息
      getCardDetail(){
        return new Promise((s)=>{
          this.$http
            .get(`aocampaigncallingcard/openapi/customer/callingcard/cardDetail/${this.shareId}`)
            .then((res) => {
              document.title = res.data.name+'的名片'
              s(res.data)
            })
        })
      },
      //推荐人头像
      getRecommendImage(){
        this.$http
          .get(`aocampaigncallingcard/openapi/customer/callingcard/recommendAvatar/${this.shareId}`)
          .then((res) => {
            if(res.data){
              this.recommendImageList=res.data
            }
          })
      },
      //推荐活动
      getRecommendActivityl(){
        this.$http
          .get(`aocampaigncallingcard/openapi/customer/callingcard/recommendActivity/${this.shareId}`)
          .then((res) => {
            this.activityList=res.data
          })
      },
      //推荐内容
      getRecommendContent(){
        this.$http
          .get(`aocampaigncallingcard/openapi/customer/callingcard/recommendContent/${this.shareId}`)
          .then((res) => {
             if(res.data){
               let materialsList=res.data
                materialsList.forEach((item)=>{
                  if(item.model){
                    item.model.moments_pics=JSON.parse(item.model.moments_pics)
                    if (Array.isArray(item.model.pic)) {
                      item.model.pic = item.model.pic[0];
                    }
                    if (item.model.type == 3) {
                      item.model.videoUrl = item.model.url;
                    }
                  }
                })
                this.contentList=materialsList
                if(materialsList.length>0){
                  this.getContentChannel()
                }
                console.log('this.contentList',this.contentList)
             }
          })
      },
      //渠道id
      getContentChannel(){
        this.$http
          .get(`aocampaigncallingcard/openapi/sales/calling-card/content-channel`)
          .then((res) => {
             if(res.data){
               this.multiChannelId=res.data
             }
          })
      },
      //咨询
      clickAdvisory(){
        this.callingcardShow=true
      },
      //跳转到活动详情
      clickActivityList(){
        let token=Vue.ls.get('ssToken')
        if(token) {
           this.$router.push(`./activityList`)
        }else{
           Vue.ss.set('wxUserInfoLogin','wxUserInfoLogin')
           Vue.ss.set('pageUrl',`shareId=${this.shareId}`)
           this.$store.dispatch("wxLogin/wxUserInfoLogin")
        }
      },
      //距离
      async getStoreLocation(){
        let that=this;
        let location=await that.getLocation()
        if(location){
          that.getInstance(location)
        }
      },
      getLocation(){
        return new Promise((s) => {
          window.wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              if(res&&res.latitude&&res.longitude){
                 s(res)
              }
            }
          });
        })
      },
      //门店距离
      getInstance(location){
        let that=this;
        that.$http
          .get(`aocampaigncallingcard/openapi/customer/callingcard/instance/${that.shareId}?location=${location.latitude},${location.longitude}`)
          .then((res) => {
            let number=parseInt(res.data)
            if(number<1000){
              number=number+'米'
            }else{
              number=(Math.round(number/100)/10).toFixed(1) + "km"
            }
            console.log('门店'+number)
            that.locationNumber=number
          })
      },
      //海报成功
      onImgOK(e){
        this.eacrdImg=e
      },
      
  },
};
</script>
<style lang="less" scoped>
.bg{
  width: 100%;
  height:237px;
  background: url('../../assets/electronicCard/bg.png');
}
.title {
  color: #000000;
  font-size: 16px;
  line-height: 22px;
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: 100%;
  box-shadow: 0px -2px 4px rgba(121, 121, 121, 0.08);
  background: #fff;
  padding:10px 32px;
}
.swipeItemTitle{
  background: linear-gradient(0deg, #000000 0%, #000000 100%);
  mix-blend-mode: multiply;
  opacity: 0.6;
  height:38px;
  line-height: 38px;
  color: #EBEDF0;
  font-size: 13px;
  padding:0 12px;
}
</style>
